<div class="container py-3">
  <h2>Inactive Users Admin</h2>

  <!-- Section 1: Sync from Auth0 -->
  <div class="card mb-3">
    <div class="card-body">
      <h4 class="card-title mb-2">Sync all users’ last login date from Auth0</h4>
      <button class="btn btn-primary" (click)="onSyncNow()" [disabled]="loading">Sync Now</button>
    </div>
  </div>

  <!-- Section 2: Filter by date -->
  <div class="card">
    <div class="card-body">
      <div class="d-flex align-items-center mb-2">
        <h4 class="card-title mb-0 me-2">Users last login before</h4>
        <input class="form-control" type="date" [(ngModel)]="targetDate" style="max-width: 220px;"/>
      </div>
      <div class="mb-2">
        <button class="btn btn-outline-primary me-2" (click)="onList()" [disabled]="loading">List user(s)</button>
        <button class="btn btn-danger" (click)="onDelete()" [disabled]="loading">Del user(s)</button>
      </div>

      <!-- Count row (one line below buttons) -->
      <div class="text-muted mb-2" *ngIf="listed">
        Found {{items.length}} user(s)
      </div>

      <div class="table-responsive">
        <table class="table table-sm table-striped align-middle">
          <thead>
            <tr>
              <th>Email</th>
              <th>last_login_date</th>
              <th>user_id</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let it of items">
              <td>{{it.email}}</td>
              <td>{{it.lastLoginDate || '—'}}</td>
              <td>{{it.userId}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
